"use client";

import { PayloadLink } from "@/components/shared/PayloadLink";
import { transformFooterData } from "@/lib/footer-utils";
import { siteConfig } from "@/lib/site.config";
import type { Footer } from "@/payload-types";

interface FooterBottomProps {
  footer: Footer;
}

const STORAGE_KEY = siteConfig.cookieStorageKey;

export function FooterBottom({ footer }: FooterBottomProps) {
  const footerData = transformFooterData(footer);
  if (!footerData) return null;

  const { companyInfo, copyright, legalLinks } = footerData;

  const handleManagePreferences = () => {
    window.localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new CustomEvent("cookie-consent-reopen"));
  };

  return (
    <div className="bg-black border-x border-b border-white/15">
      {/* Padding matches the grid cells above (p-3 sm:p-4 lg:p-5) so the
          tagline / legal links line up with the columns rather than indenting
          further from the right edge. */}
      <div className="w-full px-3 sm:px-4 lg:px-5 py-3">
        <div className="flex flex-col gap-2 text-sm text-white/60 sm:flex-row sm:items-center sm:justify-between">
          {companyInfo?.tagline && (
            <span className="text-left">{companyInfo.tagline}</span>
          )}
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 sm:ml-auto">
            {legalLinks?.map((link, index) => (
              <PayloadLink
                key={link.id || index}
                type="page"
                page={typeof link.page === "number" ? null : link.page}
                className="text-white/60 underline underline-offset-4 transition-colors hover:text-white"
              >
                {link.label}
              </PayloadLink>
            ))}
            <button
              type="button"
              onClick={handleManagePreferences}
              className="cursor-pointer text-white/60 underline underline-offset-4 transition-colors hover:text-white"
            >
              Manage cookie preferences
            </button>
            <span className="text-right">
              {copyright ||
                `\u00A9 ${new Date().getFullYear()} ${siteConfig.name}. All rights reserved.`}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
